module.exports = __webpack_public_path__ + "img/flamethrower-turret-gun-extension.a0fe7712.png";